import React, { Component } from "react"
import PropTypes from "prop-types"
import SbEditable from "storyblok-react"
import fetch from "cross-fetch"
import { filter, indexOf } from "lodash"
import * as Icon from "react-feather"

import Campus from "../campus"
import Select from "../input/Select"

class Location extends Component {
  state = {
    programFilter: "",
    programs: [],
  }

  componentDidMount() {
    fetch(
      `//api.storyblok.com/v1/cdn/datasource_entries?datasource=programs&token=${
        process.env.GATSBY_PUBLIC_SB_TOKEN
      }&ts=${Date.now ? Date.now() : new Date().getTime()}`
    )
      .then(res => {
        if (res.status >= 400) {
          throw new Error("Bad response from server")
        }
        return res.json()
      })
      .then(programs => {
        this.setState({
          programs: programs.datasource_entries,
        })
      })
      .catch(err => {
        console.error(err)
      })
  }

  onProgramFilterChange = event => {
    const { value } = event.target

    this.setState(
      {
        programFilter: "reset",
      },
      () => {
        this.setState({
          programFilter: value,
        })
      }
    )
  }

  filterLocationsByProgram() {
    const { blok } = this.props
    const { programFilter } = this.state

    if (!blok.location_campus) {
      return []
    }

    return filter(blok.location_campus, campus => {
      if (programFilter === "") {
        return true
      }

      return campus.programs && ~indexOf(campus.programs, programFilter)
    })
  }

  render() {
    const { blok } = this.props
    const { programs } = this.state
    const locationCampus = this.filterLocationsByProgram()

    return (
      <SbEditable content={blok}>
        <div className="location">
          {blok.isFilterable && (
            <div className="location__tools card card--pd-md">
              <div className="location__title">
                <Icon.MapPin className="location__icon icon icon--sm" />
                <p>{blok.heading}</p>
              </div>
              <Select
                label="Filter locations by program"
                text="Filter by Program"
                className="location__select"
                onChange={this.onProgramFilterChange}
              >
                <option value="">All</option>
                {programs &&
                  programs.map(prog => (
                    <option key={prog.id} value={prog.value}>
                      {prog.name}
                    </option>
                  ))}
              </Select>
            </div>
          )}
          <div className="location__list">
            {locationCampus.map(content => (
              <Campus key={content._uid} blok={content} />
            ))}
          </div>
        </div>
      </SbEditable>
    )
  }
}

Location.propTypes = {
  blok: PropTypes.shape({
    heading: PropTypes.string,
    isFilterable: PropTypes.bool,
    location_campus: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string,
        link: PropTypes.object,
        programs: PropTypes.arrayOf(PropTypes.string),
      })
    ),
  }).isRequired,
}

export default Location
